import React, { FunctionComponent, useState } from "react";
import { Aside, ListActionButtonProps, Stack } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { EditGpacMuxSpecificationForm } from "../forms/edit/EditGpacMuxSpecificationForm";
import { MuxSpecificationListingItem } from "../MuxSpecificationListingItem";

export const EditGpacMuxSpecificationButton: FunctionComponent<ListActionButtonProps<MuxSpecificationListingItem>> = (
    props: ListActionButtonProps<MuxSpecificationListingItem>
) => {
    const { disabled, itemId } = props;
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const isButtonDisabled = disabled;

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <EditListButton onClick={openAside} disabled={isButtonDisabled} />
            <Aside type={"form"} isOpen={isAsideOpen} headerText="Edit GPAC Mux Specification" onDismiss={closeAside}>
                <Stack>
                    <EditGpacMuxSpecificationForm onCancel={closeAside} onSubmit={handleFormSubmit} itemId={itemId} />
                </Stack>
            </Aside>
        </>
    );
};
